export const EditIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    role="img"
    aria-label="Edit"
  >
    <path
      d="M2.72659 11.7921C2.84371 11.3752 3.06367 10.9953 3.37218 10.6869L8.54831 5.51173L9.51669 4.54353C9.99088 5.01764 10.9821 6.00868 12.4875 7.51381L13.4559 8.482L12.4875 9.4502L7.31141 14.6253C7.00575 14.9309 6.62297 15.1537 6.20591 15.2708L2.5552 16.2875C2.3181 16.3532 2.06101 16.2875 1.88676 16.1105C1.71251 15.9334 1.64681 15.6792 1.71251 15.4422L2.72659 11.7921ZM4.31485 11.6865C4.18916 11.8207 4.09775 11.9835 4.04919 12.1606L3.36076 14.6425L5.84313 13.9542C6.02595 13.9028 6.19163 13.8085 6.32874 13.6771L4.312 11.6865H4.31485ZM14.4272 7.51381C13.953 7.03971 12.9617 6.04866 11.4563 4.54353L10.4851 3.57534C11.2421 2.81849 11.6677 2.39294 11.7677 2.29298C12.1533 1.90456 12.6789 1.6875 13.2274 1.6875C13.7759 1.6875 14.3015 1.90456 14.6871 2.29298L15.7069 3.31258C16.0954 3.701 16.3125 4.22651 16.3125 4.77202C16.3125 5.31752 16.0954 5.84589 15.7069 6.23145C15.6069 6.33141 15.1813 6.75696 14.4243 7.51381H14.4272Z"
      fill="currentColor"
    />
  </svg>
);
